const screenerNavigationRoutes = {
  SCREENER_HOME: "/",
  COMPANY_DETAILS: (id: string) => `company-details/${id}`,
  COMPANY_DETAILS_ROUTE: "company-details/:id",
} as const;

export default screenerNavigationRoutes;
